import { createTheme } from "@mui/material";

export const theme = createTheme({
    palette: {
        primaryBlue: {
            main: '#08509A',
            light: '#087d9a',
            hover: '#0f7ff2',
            contrastText: '#000',
        },
        //   secondary: {
        //     main: '#f50057',
        //     light: '#ff4081',
        //     dark: '#c51162',
        //     contrastText: '#000',
        //   },
        //   customColor: {
        //     main: '#ff9800',
        //     light: '#ffb74d',
        //     dark: '#f57c00',
        //   },
    },
    typography: {
        fontFamily: 'Monserrat, sans-serif',
        button: {
            textTransform: 'none',
            fontWeight: 'bold',
        },
    },
});